import {
  createEntityAdapter,
  configureStore,
} from '@reduxjs/toolkit'
import reducers from './reducers'


const store = configureStore({
  reducer: reducers,
  devTools: {
    name: 'Dashboard overview',
  },
})

export default store
